export default __webpack_public_path__ + "./images/ls.898867af.png";